module.exports = __webpack_public_path__ + "img/C04RigorousTraining_ua.7150a3c0.webp";